import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import '../css/Home.css';
import Modal from 'react-modal';
import { Icon, Collapsible, CollapsibleItem } from 'react-materialize'
import { connect } from 'react-redux'
import LocalizedStrings from 'react-localization';
import { data } from '../js/data.js';
import { fontSizeToggleAction } from '../js/actions/fontSizeToggleAction'
import LanguageSelect from './LanguageSelect'


const oneMinute = 60000; /* milliseconds */
const oneHour = 3600000; /* milliseconds */
const oneDay = 86400000; /* milliseconds */

let strings = new LocalizedStrings(data);

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class Home extends Component {
    constructor() {
        super();
        var dncExpiry = (Date.now() - localStorage.getItem('time') > oneDay || localStorage.getItem('time') === 0);
        this.state = {
            open: false,
            modalIsOpen: dncExpiry,
            dncExpiry: dncExpiry,
            PostedAnnouncementList: [],
            language: ''
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        Modal.setAppElement('body');
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    doNotShowOneDay = () => {
        localStorage.setItem('time', Date.now());
        this.setState({ modalIsOpen: false });
    }

    showdnc = () => {
        if(true){
            return(
                <Button onClick={this.doNotShowOneDay}> {strings.doNotShowOneDay} </Button>
            )  
        }
    }

    /* For language dialog */
    handleClickOpen = () => {
        this.setState({
          open: true,
        });
    };
    /* For language dialog */
    handleClose = value => {
        this.setState({ selectedValue: value, open: false });
    };

    render() {
        const threeDays = 259200000; /* in milliseconds */
        const{ announcements } = this.props;

        strings.setLanguage(this.props.languages);

        return (
            <body>
                <div>
                    <div>
                        <Button class="announcement-icon"><a onClick={this.openModal}><Icon className='small'>add_alert</Icon></a></Button>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <h3 className="Title-two"> {strings.announcements} <Button onClick={this.closeModal}><Icon className='small'>clear</Icon></Button></h3>
                            <Collapsible popout>

                                {
                                    announcements.map((item) => {
                                        if((Date.now() - item.postedTime) < threeDays){
                                            return (
                                                <CollapsibleItem class='font-red' header={item.Title}>
                                                    {item.Announcement}
                                                </CollapsibleItem>
                                            )
                                        } else {
                                            return (
                                                <CollapsibleItem header={item.Title}>
                                                    {item.Announcement}
                                                </CollapsibleItem>
                                            )
                                        }
                                    })
                                }
                            </Collapsible>
                            <Button onClick={this.doNotShowOneDay}
                                    style= {
                                        {
                                          borderRadius: '2px',
                                          border: 'solid 1px #d8dde3',
                                          borderColor: '#000'
                                        }
                                    }
                            >
                                {strings.doNotShowOneDay}
                            </Button>
                        </Modal>
                    </div>
                    <header className="App-header">
                        <a href="/">
                            <img src="https://images.glaciermedia.ca/polopoly_fs/1.684178.1526061933!/fileImage/httpImage/image.jpg_gen/derivatives/landscape_804/fraser-health-logo.jpg" alt="Fraser Health Logo" width="100" height="90" data-variantitemid="{7F1325C2-05A1-4630-8B5F-69A5F09BABB3}" data-variantfieldname="Image" ></img>
                        </a>

                        <p className={(this.props.isFontSizeEnabled ? 'Title-one-large' : 'Title-one')}>
                        {strings.welcomeTo}
                        <h1 className={(this.props.isFontSizeEnabled ? 'Title-two-large' : 'Title-two')}>
                                {strings.rch}
                            </h1>
                        </p>

                        <Link to="/scan">
                            <Button id={(this.props.isFontSizeEnabled ? 'Btn-scan-large' : 'Btn-scan')}
                                // class="btn-large btn-scan btn-blue"
                                node="a"
                                waves="light"
                                large
                                // id="addBut"
                                style={{ marginBottom: '10px', 
                                         backgroundColor: (this.props.isColourBlindEnabled ? '#222222' : '#20568d'), 
                                         color: (this.props.isColourBlindEnabled ? '#fff' : '#fff') 
                                        }}
                            >
                                {strings.scanMyLocation}
                            </Button>
                        </Link>

                        <Link to="/currentlocation">
                            <Button id={(this.props.isFontSizeEnabled ? 'Btn-dir-large' : 'Btn-dir')}
                            // "btn-large btn-dir btn-grey"
                                node="a"
                                waves="light"
                                large
                                style={{ marginBottom: '10px', 
                                         backgroundColor: (this.props.isColourBlindEnabled ? '#222222' : '#cccccc'), 
                                         color: (this.props.isColourBlindEnabled ? '#fff' : '#222222') 
                            }}
                            >
                                {strings.directions}
                            </Button>
                        </Link>

                        <Button id={(this.props.isFontSizeEnabled ? 'Btn-lang-large' : 'Btn-lang')}
                        // class="btn-large btn-dir btn-red"
                            node="a"
                            waves="light"
                            large
                            style={{ marginBottom: '10px',
                                     backgroundColor: (this.props.isColourBlindEnabled ? '#222222' : 'rgb(209, 91, 39)'), 
                                     color: (this.props.isColourBlindEnabled ? '#fff' : '#fff') 
                        }}
                            onClick={this.handleClickOpen}
                        >
                        {strings.language} 
                        </Button>
                        <LanguageSelect
                            selectedValue={this.state.selectedValue}
                            open={this.state.open}
                            onClose={this.handleClose}
                            language={this.state.language}
                        />



                        <div id="accessibilityButtons">

                        <Button id="Font-size-toggle-button"
                                onClick={this.props.fontSizeToggleAction}
                                style= {
                                    {
                                      borderRadius: '2px',
                                      width: '60px',
                                      border: 'solid 1px #d8dde3',
                                      borderColor: '#000'
                                    }
                                }
                                >
                                <i class="material-icons">text_fields</i>
                        </Button>
                        </div>
                    </header>
                </div>
            </body>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        announcements: state.announcements.announcements,
        maps: state.maps.maps,
        isFontSizeEnabled: state.isFontSizeEnabled.isFontSizeEnabled,
        languages: state.language.language
    }
}

const mapDispatchToProps = dispatch => ({
    fontSizeToggleAction: () => dispatch(fontSizeToggleAction),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
